import React from 'react';
import { map, isEmpty, compact } from 'lodash';
import { useTranslation } from 'react-i18next';

const Pagination = (props) => {
  const { t } = useTranslation();
  const { selectedStage, onPrevClick, onNextClick, paginationMax, touched, errors } = props;

  return (
    <div className={'paginationButtons'}>
      {selectedStage > 0 && selectedStage + 1 !== paginationMax && (
        <div onClick={onPrevClick} id={'buttonPrev'} className={'buttonPagination paginationPrev text-2xl'}>
          {t('PREV')}
        </div>
      )}
      {selectedStage > 0 && selectedStage + 1 < paginationMax && (
        <div
          onClick={(e) => {
            e.preventDefault();
            console.log('18', touched, errors);
            const isErrors = !isEmpty(compact(map(touched, (_value, key) => errors[key] && key)));
            if (isErrors) {
              return;
            }
            onNextClick();
          }}
          id={'buttonNext'}
          className={'buttonPagination paginationNext text-2xl #04c700'}
        >
          {t('NEXT')}
        </div>
      )}
    </div>
  );
};

export default Pagination;
